import { useInjection } from "@linkfluence/core/di";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  InsightPage,
  InsightPageRecurringSnapshot,
} from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useDeleteRecurringSnapshot() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    ({
      project,
      pageId,
      recurringSnapshotId,
    }: {
      project: number;
      pageId: InsightPage["id"];
      recurringSnapshotId: InsightPageRecurringSnapshot["id"];
    }) => {
      return repository.deleteRecurringSnapshot(
        project,
        pageId,
        recurringSnapshotId
      );
    },
    {
      onSuccess: (success, { project, pageId }) => {
        queryClient.invalidateQueries([
          "/recurring-snapshots/list",
          {
            project,
            id: pageId,
          },
        ]);
      },
    }
  );
  const deleteRecurringSnapshot = (data: {
    project: number;
    pageId: InsightPage["id"];
    recurringSnapshotId: InsightPageRecurringSnapshot["id"];
  }) => {
    mutate(data);
  };
  return {
    deleteRecurringSnapshot,
    loading: isLoading,
  };
}
